import { configs } from '@/configs';
import { MENU_LINK } from '@/layouts/header/constants';
import { getAssetTopView, getAssetTopWithType } from '@/services';
import type { NftMarket } from '@/types';
import { useSQuery } from '@/utils';

const isProduction = configs.ssoCallback === 'https://airight.io';

const ASSET_TAGS = {
  art: {
    id: isProduction ? 7 : 28,
    content: 'art',
  },
  gaming: {
    id: isProduction ? 1387 : 97,
    content: 'gaming',
  },
  pfps: {
    id: isProduction ? 1388 : 98,
    content: 'pfps',
  },
};

const useTrendingType = () => {
  const { data: topViewData } = useSQuery({
    queryKey: ['get-top-asset-view'],
    queryFn: () => getAssetTopView({ size: 20, offset: 0 }),
    keepPreviousData: true,
  });

  const { data: topArtData } = useSQuery({
    queryKey: ['get-top-asset-art'],
    queryFn: () => getAssetTopWithType({ limit: 6, type: 'art' }),
    keepPreviousData: true,
  });

  const { data: topGameData } = useSQuery({
    queryKey: ['get-top-asset-game'],
    queryFn: () => getAssetTopWithType({ limit: 6, type: 'gaming' }),
    keepPreviousData: true,
  });

  const { data: topPFPsData } = useSQuery({
    queryKey: ['get-top-asset-PFPs'],
    queryFn: () => getAssetTopWithType({ limit: 6, type: 'PFPs' }),
    keepPreviousData: true,
  });

  const topViewList: NftMarket[] = topViewData?.data?.items ?? [];
  const topArtList: NftMarket[] =
    topArtData?.data?.items.map((item: any) => ({ ...item.offer, asset: item })) ?? [];
  const topGameList: NftMarket[] =
    topGameData?.data?.items.map((item: any) => ({ ...item.offer, asset: item })) ?? [];
  const topPFPsList: NftMarket[] =
    topPFPsData?.data?.items.map((item: any) => ({ ...item.offer, asset: item })) ?? [];

  const urlArtCategory = `${
    MENU_LINK.marketplace
  }?category=artwork&assetCategory=image&tagIds=${encodeURIComponent(
    JSON.stringify([ASSET_TAGS.art.id]),
  )}&tags=${encodeURIComponent(
    JSON.stringify([{ label: ASSET_TAGS.art.content, value: ASSET_TAGS.art.id }]),
  )}`;
  const urlGamingCategory = `${
    MENU_LINK.marketplace
  }?category=artwork&assetCategory=image&tagIds=${encodeURIComponent(
    JSON.stringify([ASSET_TAGS.gaming.id]),
  )}&tags=${encodeURIComponent(
    JSON.stringify([{ label: ASSET_TAGS.gaming.content, value: ASSET_TAGS.gaming.id }]),
  )}`;
  const urlPFPsCategory = `${
    MENU_LINK.marketplace
  }?category=artwork&assetCategory=image&tagIds=${encodeURIComponent(
    JSON.stringify([ASSET_TAGS.pfps.id]),
  )}&tags=${encodeURIComponent(
    JSON.stringify([{ label: ASSET_TAGS.pfps.content, value: ASSET_TAGS.pfps.id }]),
  )}`;

  return {
    topViewList,
    topArtList,
    topGameList,
    topPFPsList,
    urlArtCategory,
    urlGamingCategory,
    urlPFPsCategory,
  };
};

export default useTrendingType;
